/**
 电站运行看板--运行看板
 */

import React, { Component } from "react";
import { Progress, Tooltip, Popover } from "antd";
import {
  getCityList,
  equipmentQry,
  userManagerRegionList,
  querySuccessRate,
} from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import FormCore from "@/components/display/form/formCore";
import moment from "moment";
import PropTypes from "prop-types";
// // 图片
// import icon1 from "@/assets/img/displayBoard/stationIcon.png";
// import icon2 from "@/assets/img/displayBoard/powerboxIcon.png";
// import icon3 from "@/assets/img/displayBoard/stubIcon.png";
// 组件
import StubState from "@/pages/displayBoard/stubState";
// import ChargSuccess from "@/pages/displayBoard/chargSuccess";
// import FinanceMoney from "@/pages/displayBoard/financeMoney";
// import CityRankList from "@/pages/displayBoard/cityRankList";
import MaintenanceDevices from "@/pages/displayBoard/maintenanceDevices";

// import ElecticalLossBoard from "@/pages/displayBoard/electicalLossBoard";
// import ExceptionBoard from "@/pages/displayBoard/exceptionBoard";
// import PeopleTicketCount from "@/pages/displayBoard/peopleTicketCount";
import GroundLockBoard from "@/pages/displayBoard/groundLockBoard";
import PublicChargingPile from "@/pages/displayBoard/publicChargingPile";

// css
import "@/assets/stylus/displayBoard.styl";
// icon
import { RightOutlined, QuestionCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class DisplayBoardIndex extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;

    this.state = {
      timeType: "pickDate",
      areaList: [
        {
          text: "全部",
          value: "",
        },
      ],
      param: {
        isMonth: 2,
        stubType: "",
        cityIds: "",
        provinceIds: "000000", // 默认 000000全国
        date: moment(new Date()).subtract(1, "d").format("YYYY-MM-DD"),
        operationProperty: "3",
        operationMode: "",
      },
      equipmentQry: {
        station: 0, // 桩群数量
        powerBox: 0, // 配电柜数量
        stub: 0, // 桩数量
      },
      successRate: "0",
      stubIntactRate: "0",
      intactRateSequential: 0,
      stationCompareRate: 0,
      stubCompareRate: 0,
      intactCompareRate: 0,
      successCompareRate: 0,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 页面加载前方法
  componentWillMount() {
    this.setState({
      formConfig: this.initForm(),
    });
    this.getCityList();
    this.getEquipmentQry();
    this.getAreaList();
    this.getSuccessRate();
  }

  // 页面加载完成方法
  componentDidMount() {}

  /**
   * 获取充电成功率数字
   */
  getSuccessRate = (value) => {
    // console.log(value);
    this.setState({
      successRate: value,
    });
  };

  /**
   * 获取负责的大区列表
   */
  getAreaList() {
    let that = this;
    fetchHandler(userManagerRegionList, {
      userId: sessionStorage.getItem("userId"),
    }).then((res) => {
      if (res.data) {
        res.data.forEach(function (item) {
          item.text = item.regName;
          item.value = item.areaId;
        });
        res.data.unshift({
          text: "全部",
          value: "",
        });
        this.setState(
          {
            areaList: res.data,
          },
          () => {
            this.setState({
              formConfig: this.initForm(),
            });
          },
        );
      }
    });
  }

  /**
   * 获取设备完好率数字
   */
  getStubIntactRate = (value, sequential) => {
    this.setState({
      stubIntactRate: value,
      intactRateSequential: sequential || 0, //设备完好率环比
    });
  };

  /**
   * 获取设备数据
   */
  getEquipmentQry() {
    const { date, startTime, endTime } = this.state.param;
    fetchHandler(equipmentQry, {
      startTime: this.state.param.isMonth === 3 ? startTime : date,
      endTime: this.state.param.isMonth === 3 ? endTime : date,
      cityIds: this.state.param.cityIds,
      isMonth: this.state.param.isMonth,
      stubType: this.state.param.stubType,
      operationMode: this.state.param.operationMode,
      operationProperty: "3",
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      // console.log(res);
      if (res.data) {
        this.setState({
          equipmentQry: {
            station: res.data.stubGroupQuantity,
            powerBox: res.data.powerBoxQuantity,
            stub: res.data.stubQuantity,
          },
        });
      }
    });
  }

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList, { userId: sessionStorage.getItem("userId") }).then((res) => {
      if (!res.data) {
        return;
      }
      const fetchPickerOptions = res.data;
      let formatOptionsStr = JSON.stringify(fetchPickerOptions);
      formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
      const cityAryy = JSON.parse(formatOptionsStr);
      cityAryy.map((item) => {
        item.key = item.value;
        item.children.map((item2) => {
          item2.key = item2.value;
          delete item2.children; // 删除子区域数据
          return true;
        });
        return true;
      });
      // 初始化城市数据
      // this.quanguoCityArry = [
      //   {
      //     title: "全国",
      //     value: "000000",
      //     key: "000000",
      //     children: JSON.parse(JSON.stringify(cityAryy)),
      //   },
      // ];

      this.quanguoCityArry = JSON.parse(JSON.stringify(cityAryy));
      // 只能选择城市的方式
      this.quanguoCityNotP = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotP.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = false;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择省份的数组
      this.quanguoCityNotCity = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotCity.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = false;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择全国的数组
      this.quanguoCityNotChild = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotChild.map((item) => {
        item.disabled = false;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 设置数据
      // console.log(this.quanguoCityArry);
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    });
  };

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = "";
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (
        value[0].charAt(5) === "0" &&
        value[0].charAt(4) === "0" &&
        value[0].charAt(3) === "0" &&
        value[0].charAt(2) === "0"
      ) {
        quanguoCityArryCVal = this.quanguoCityArry;
      } else {
        quanguoCityArryCVal = this.quanguoCityArry;
      }
      // 设置数据
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
  };

  // 获取充电成功率数据
  getSuccessRate = async () => {
    const { date, startTime, ...otherParams } = this.state.param;
    const res = await querySuccessRate({
      ...otherParams,
      startTime: this.state.param.isMonth === 3 ? startTime : date,
    });
    console.log("querySuccessRate***", res);
    if (res.data.code === "200") {
      const { successRate, sequential } = res.data.data || {};
      this.setState({
        successData: {
          chargingSuccessRate: successRate || 0,
          sequential: sequential || 0,
        },
      });
    }
  };

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  // 加载form方法
  initForm(type) {
    const formConfig = {
      childItems: [
        {
          type: "select",

          placeholder: "请选择", // '请选择大区',
          labelName: "大区", // '大区',
          param: {
            name: "areaIds",
            type: "string",
          },
          options: this.state.areaList,
          allowClear: true,
          required: false,
          onChange: async (value, form) => {
            if (value == null || value == "") {
              //恢复区域信息
              form.setFieldsValue({
                cityGroup: [],
              });
            } else {
              //遍历区域，把不属于
              form.setFieldsValue({
                cityGroup: value.split(","),
              });
            }
            this.setState({
              formConfig: this.initForm(value),
            });
          },
        },
        {
          type: "treeSelect",

          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },
        {
          type: "select",

          placeholder: "请选择", // '请选择设备状态',
          labelName: "设备类型", // '设备状态',
          param: {
            name: "stubType",
            type: "string",
          },
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "交流电",
              value: "0",
            },
            {
              text: "直流电",
              value: "1",
            },
            {
              text: "交直流",
              value: "2",
            },
          ],
          required: false,
        },
        {
          type: "select",
          width: "180px",
          placeholder: "请选择", // '请选择设备状态',
          labelName: "运营类型", // '设备状态',
          param: {
            name: "operationMode",
            type: "string",
          },
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "非直营",
              value: "0",
            },
            {
              text: "直营",
              value: "1",
            },
          ],
          required: false,
        },

        {
          type: "inputGroup",
          isArray: true,

          inputGroup: [
            {
              type: "select",
              options: [
                {
                  text: "月",
                  value: "1",
                },
                {
                  text: "日",
                  value: "0",
                },
                {
                  text: "跨度",
                  value: "3",
                },
              ],
              // width:'80px',
              width: "100px",
              // placeholder: ['请选择',],
              param: {
                name: "searchType",
                type: "string",
              },
              defaultValue: "0",
              onChange: (value, form) => {
                // 日期类型选择后执行，设置日期选择样式
                form.setFieldsValue({
                  searchType: value,
                });
                if (value === "0") {
                  this.setState(
                    {
                      timeType: "pickDate",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initForm(value),
                      });
                    },
                  );
                } else if (value === "1") {
                  this.setState(
                    {
                      timeType: "pickMonth",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initForm(value),
                      });
                    },
                  );
                } else if (value === "3") {
                  this.setState(
                    {
                      timeType: "rangeDate",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initForm(value),
                      });
                    },
                  );
                }
              },
              allowClear: false,
              labelName: "日期:",
              required: false,
            },
            {
              type: "date",
              dateType: this.state.timeType,
              // width:'140px',
              width: "200px",
              allowClear: false,
              param: {
                name: this.state.timeType === "rangeDate" ? "dateRange" : "date",
                type: this.state.timeType === "rangeDate" ? "array" : "object",
              },
              disabledDate: (current) => {
                let flag = false;
                if (current < moment(new Date("2020-01-01")).endOf("day")) {
                  flag = true;
                }

                if (current && current > moment(new Date()).endOf("day")) {
                  flag = true;
                }
                return flag;
              },
              defaultValue:
                this.fromParam == null
                  ? this.state.timeType === "pickMonth"
                    ? moment(new Date()).subtract(0, "m")
                    : this.state.timeType === "rangeDate"
                    ? [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(1, "d")]
                    : moment(new Date()).subtract(1, "d")
                  : moment(this.fromParam.date).subtract(1, "d"),
              validator:
                this.state.timeType === "rangeDate"
                  ? {
                      // 日期自定义校验规则
                      vtype: "date", // 校验名称
                      min_val: 0, // 可选最小天数
                      max_val: 92, // 最大可选天数
                    }
                  : null,
              required: false,
            },
          ],
        },
        // {
        //   type: "date",
        //   dateType: "pickDate",
        //   placeholder: "年/月/日",
        //   param: {
        //     name: "date",
        //     type: "object",
        //   },
        //   disabledDate: (current) => {
        //     if (current < moment(new Date()).subtract(31, "d")) {
        //       return current < moment(new Date()).subtract(31, "d");
        //     }
        //     return current && current > moment(new Date()).subtract(1, "d");
        //   },
        //   allowClear: false,
        //   defaultValue: moment(new Date()).subtract(1, "d"),
        //   validator: {
        //     // 日期自定义校验规则
        //     vtype: "date", // 校验名称
        //     min_val: 0, // 可选最小天数
        //   }, // 自定义校验规则
        //   labelName: "查询时间",
        // },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              message: "环比:数据与前一天比较",
              text: "查询",
              // icon: "search",
              handler: (e, param) => {
                let that = this;
                // 设置城市数组
                let cityIds = "";
                // if (param.cityGroup) {
                //   param.cityGroup.map((item) => {
                //     cityIds += `${item},`;
                //       return true;
                //   });
                // }
                // 判断选择地区类型（全国、省份、城市）
                let cityType = "0"; // 0：全国，1：省份，2：城市
                if (param.cityGroup !== undefined) {
                  if (param.cityGroup.length === 0) {
                    // console.info("问问3");
                    // cityIds = "000000";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry.forEach(function (item) {
                      item.children.forEach(function (one) {
                        ids.push(one.key);
                      });
                    });
                    cityIds = ids.join(",");
                  } else if (param.cityGroup[0] === "000000") {
                    // console.info("问问4");
                    // cityType = "0";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry.forEach(function (item) {
                      item.children.forEach(function (one) {
                        ids.push(one.key);
                      });
                    });
                    cityIds = ids.join(",");
                  } else if (
                    param.cityGroup[0].charAt(5) === "0" &&
                    param.cityGroup[0].charAt(4) === "0" &&
                    param.cityGroup[0].charAt(3) === "0" &&
                    param.cityGroup[0].charAt(2) === "0"
                  ) {
                    var ids = [];
                    cityType = "2";
                    param.cityGroup.forEach(function (info) {
                      if (
                        info.charAt(5) === "0" &&
                        info.charAt(4) === "0" &&
                        info.charAt(3) === "0" &&
                        info.charAt(2) === "0"
                      ) {
                        that.state.quanguoCityArry.forEach(function (item) {
                          if (info == item.key) {
                            item.children.forEach(function (one) {
                              ids.push(one.key);
                            });
                          }
                        });
                      } else {
                        ids.push(info);
                      }
                    });
                    // console.info("问问5");
                    cityIds = ids.join(",");
                  } else {
                    // console.info("问问6" + cityIds);
                    cityType = "2";
                    this.state.quanguoCityArry.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (param.cityGroup.indexOf(one.key) != -1) {
                          cityIds += `${one.key},`;
                        }
                      });
                    });
                  }
                } else {
                  // console.info("问问7");
                  var ids = [];
                  cityType = "2";
                  // console.info(this.state.quanguoCityArry);
                  //省份下的城市 cityIds改成所选省份下的城市
                  this.state.quanguoCityArry.forEach(function (item) {
                    item.children.forEach(function (one) {
                      ids.push(one.key);
                    });
                  });
                  cityIds = ids.join(",");
                }
                // if (param.cityGroup !== undefined) {
                //   if (param.cityGroup.length === 0) {
                //     cityType = "0";
                //     cityIds = "000000";
                //   } else if (param.cityGroup[0] === "000000") {
                //     cityType = "0";
                //   } else if (
                //     param.cityGroup[0].charAt(5) === '0'
                //     && param.cityGroup[0].charAt(4) === '0'
                //     && param.cityGroup[0].charAt(3) === '0'
                //     && param.cityGroup[0].charAt(2) === '0'
                //   ) {
                //     cityType = "1";
                //   } else {
                //     cityType = "2";
                //   }
                // }
                let dateSet = "";
                let isMonth = 2; //1-按月，2-按天
                var startTime = null;
                var endTime = null;
                if (param.searchType === "1") {
                  isMonth = 1;
                  if (param.date) {
                    dateSet = param.date.format("YYYY-MM");
                  } else {
                    dateSet = moment(new Date()).format("YYYY-MM");
                  }
                  dateSet = dateSet + "-01";
                } else if (param.searchType === "3") {
                  console.log("时间范围", param);
                  //时间范围，包含起始时间
                  isMonth = 3;
                  if (
                    param.dateRange != null &&
                    param.dateRange != "" &&
                    param.dateRange.length > 0
                  ) {
                    startTime = param.dateRange[0].format("YYYY-MM-DD");
                    endTime = param.dateRange[1].format("YYYY-MM-DD");
                  }
                } else {
                  isMonth = 2;
                  if (param.date) {
                    dateSet = param.date.format("YYYY-MM-DD");
                  } else {
                    dateSet = moment(new Date()).format("YYYY-MM-DD");
                  }
                }
                this.setState(
                  {
                    param: {
                      cityIds: cityType === "2" ? cityIds || "" : "",
                      provinceIds: cityType === "0" || cityType === "1" ? cityIds || "000000" : "",
                      date: dateSet,
                      timeType: this.state.timeType,
                      isMonth: isMonth,
                      stubType: param.stubType ? param.stubType : "",
                      operationProperty: "3",
                      operationMode: param.operationMode ? param.operationMode : "",
                      startTime: startTime,
                      endTime: endTime,
                    },
                  },
                  () => {
                    // console.log(this.state.param);
                    // 查询设备数据
                    this.getEquipmentQry();
                    // 查询充电成功率
                    this.getSuccessRate();
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        operationProperty: "3",
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "oprationLogTable",
    };

    return formConfig;
  }

  // style={{ "min-width": "1440px" }}
  render() {
    const content = (
      <div className="sc-page-content display-board-page">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} />
        </div>
        <div className="page-panel">
          <div className="display-board">
            {/* <div className="item">
              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.openTab(
                      {
                        cityIds: this.state.param.cityIds,
                        provinceIds: this.state.param.provinceIds,
                        operationMode: this.state.param.operationMode,
                      },
                      {
                        key: "0101",
                        titleText: "电站列表",
                      },
                    );
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="icon-part color1">
                    <img alt="" src={icon1} className="info-img" />
                  </div>
                  <div className="stub-info-item">
                    <div className="name">
                      电站(个){" "}
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>电站为实时数据，不随选择日期变化</span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.equipmentQry.station}</div>
                  </div>
                </div>
              </div> */}
            {/* <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.openTab(
                      {
                        cityIds: this.state.param.cityIds,
                        provinceIds: this.state.param.provinceIds,
                      },
                      {
                        key: "0104",
                        titleText: "配电柜管理",
                      },
                    );
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="icon-part color2">
                    <img alt="" src={icon2} className="info-img" />
                  </div>
                  <div className="stub-info-item">
                    <div className="name">
                      配电柜(台)
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>配电柜为实时数据，不随选择日期变化</span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.equipmentQry.powerBox}</div>
                  </div>
                </div>
              </div> */}
            {/* <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.openTab(
                      {
                        cityIds: this.state.param.cityIds,
                        provinceIds: this.state.param.provinceIds,
                        stubType: this.state.param.stubType,
                        operationMode: this.state.param.operationMode,
                      },
                      {
                        key: "0102",
                        titleText: "公充设备查询",
                      },
                    );
                  }}>
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="icon-part color3">
                    <img alt="" src={icon3} className="info-img" />
                  </div>
                  <div className="stub-info-item">
                    <div className="name">
                      枪数
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.equipmentQry.stub}</div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="item" style={{ width: "100%" }}>
              <PublicChargingPile
                equipmentQry={this.state.equipmentQry}
                successData={this.state.successData}
                equipmentHealthRate={this.state.stubIntactRate}
                equipmentHealthRateSequential={this.state.intactRateSequential}
                params={this.state.param}
                openTab={this.openTab}
              />
            </div>
            {/* <div className="item">
              <div className="inner progress-inner">
                <div className="detail-info rate-num-board progress-inner">
                  <div className="left-part">
                    <div className="ratenum">{this.state.stubIntactRate}%</div>
                    <div className="text-tit">设备完好率</div>
                  </div>
                  <div className="progress color1">
                    <Progress
                      percent={parseInt(this.state.stubIntactRate)}
                      showInfo={false}
                      strokeColor="#3AA0FF"
                    />
                  </div>
                </div>
              </div> */}
            {/* <div className='inner progress-inner'>
                <div className='detail-info rate-num-board progress-inner'>
                  <div className='left-part'>
                    <div className='ratenum'>{this.state.successRate}%</div>
                    <div className='text-tit'>充电成功率</div>
                  </div>
                  <div className='progress color1'>
                    <Progress percent={parseInt(this.state.successRate)} showInfo={false} strokeColor='#75DDB2' />
                  </div>
                </div>
              </div> */}
            {/* </div> */}
            <div className="item" style={{ paddingRight: 12 }}>
              <div className="inner" style={{ height: "621px" }}>
                <div className="title">
                  <div className="title-name">设备状态</div>
                  <div
                    className="title-more"
                    onClick={() => {
                      this.openTab(
                        {
                          paramInfo: this.state.param,
                        },
                        {
                          key: "030101",
                          titleText: "设备完好率",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div>
                  <StubState getStubIntactRate={this.getStubIntactRate} param={this.state.param} />
                </div>
              </div>
            </div>
            {/* <div className="item" style={{ paddingLeft: "12px" }}>
              <div className="inner" style={{ height: "621px" }}>
                <div className="title">
                  <div className="title-name">维护中设备数量</div>
                  <div
                    className="title-more"
                    onClick={() => {
                      this.openTab(
                        {
                          paramInfo: this.state.param,
                        },
                        {
                          key: "030101",
                          titleText: "设备完好率",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div>
                  <MaintenanceDevices param={this.state.param} />
                </div>
              </div>
            </div> */}
            <MaintenanceDevices param={this.state.param} />
            <div className="item" style={{ width: "100%", marginRight: 12 }}>
              <div className="inner">
                <div className="title">
                  <div className="title-name">
                    公充地锁
                    <Tooltip title="地锁数及状态为实时数据，不随选择日期变化">
                      <QuestionCircleOutlined
                        style={{ marginLeft: "8px", color: "#999", fontSize: "14px" }}
                      />
                    </Tooltip>
                  </div>
                </div>
                <div>
                  <GroundLockBoard param={this.state.param} openTab={this.openTab} />
                </div>
              </div>
            </div>
            {/* <div className='item'>
              <div className='inner' style={{ height: "621px", display: "flex", flexDirection: "column" }}>
                <div className='title'>
                  <div className='title-name'>充电数据</div>
                  <div
                    className='title-more'
                    onClick={() => {
                      this.openTab(
                        {},
                        {
                          key: "030102",
                          titleText: "充电成功率",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <ChargSuccess getSuccessRate={this.getSuccessRate} param={this.state.param} />
                </div>
              </div>
            </div> */}
            {/* <div className="item">
              <div className="inner" style={{ height: "621px" }}>
                <div className="title">
                  <div className="title-name">
                    电损数据{" "}
                    <Popover
                      content={
                        <div>
                          <p>电损数据，单位说明</p>
                          <p>K=10的3次方,千</p>
                          <p>M=10的6次方，百万</p>
                          <p>B=10的9次方，十亿</p>
                          <p>T=10的12次方，万亿</p>
                        </div>
                      }>
                      <QuestionCircleOutlined style={{ marginLeft: "10px", color: "#999" }} />
                    </Popover>
                  </div>
                  <div
                    className="title-more"
                    onClick={() => {
                      this.openTab(
                        {
                          date: [moment().subtract(7, "d"), moment()],
                        },
                        {
                          key: "030103",
                          titleText: "电损",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div>
                  <ElecticalLossBoard param={this.state.param} />
                </div>
              </div>
            </div> */}
            {/* <div className="item">
              <div className="inner" style={{ height: "621px" }}>
                <div className="title">
                  <div className="title-name">告警统计</div>
                </div>
                <div>
                  <ExceptionBoard param={this.state.param} onAdd={this.openTab} />
                </div>
              </div>
            </div> */}

            {/* <div className="item">
              <div className="inner" style={{ height: "621px" }}>
                <div className="title">
                  <div className="title-name">人效指标</div>
                  <div
                    className="title-more"
                    onClick={() => {
                      this.openTab(
                        {},
                        {
                          key: "0303",
                          titleText: "人效指标",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div>
                  <PeopleTicketCount param={this.state.param} />
                </div>
              </div>
            </div> */}

            {/* <div className='item'>
              <div className='inner' style={{ height: "621px", display: "flex", flexDirection: "column" }}>
                <div className='title'>
                  <div className='title-name'>财务指标</div>
                  <div
                    className='title-more'
                    onClick={() => {
                      this.openTab(
                        {},
                        {
                          key: "030102",
                          titleText: "充电成功率",
                        },
                      );
                    }}>
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <FinanceMoney getSuccessRate={this.getSuccessRate} param={this.state.param} />
                </div>
              </div>
            </div> */}

            {/* <div className="item">
              <div className="inner" style={{ height: "621px" }}>
                <div className="title">
                  <div className="title-name">近30天TOP10城市排行榜</div>
                  <div
                    className="title-more"
                    onClick={() => {
                      this.openTab(
                        {
                          date: [moment().subtract(7, "d"), moment()],
                        },
                        {
                          key: "0304",
                          titleText: "城市评分",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div>
                  <CityRankList param={this.state.param} />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
    return content;
  }
}

export default injectIntl(DisplayBoardIndex);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/displayBoardIndex.js